import { render, staticRenderFns } from "./PageDisplay.vue?vue&type=template&id=65ae3a5a"
import script from "./PageDisplay.vue?vue&type=script&lang=js"
export * from "./PageDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports